import {
  Card,
  CardContent,
  Box,
  LinearProgress,
  Typography,
  Avatar,
} from "@mui/material";

const StatCard = ({
  title,
  value,
  subtitle,
  icon: Icon,
  color = "primary",
  progress,
  breakdown,
  customBreakdown,
  isEstimate = false,
}) => (
  <Card
    elevation={2}
    sx={{
      height: "100%",
      background: `linear-gradient(135deg, ${
        color === "primary"
          ? "#1976d2"
          : color === "success"
            ? "#2e7d32"
            : color === "warning"
              ? "#ed6c02"
              : color === "error"
                ? "#d32f2f"
                : "#9c27b0"
      }15, transparent)`,
      border: `1px solid ${
        color === "primary"
          ? "#1976d2"
          : color === "success"
            ? "#2e7d32"
            : color === "warning"
              ? "#ed6c02"
              : color === "error"
                ? "#d32f2f"
                : "#9c27b0"
      }30`,
    }}
  >
    <CardContent
      sx={{ height: "100%", display: "flex", flexDirection: "column" }}
    >
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <Avatar
          sx={{
            bgcolor:
              color === "primary"
                ? "primary.main"
                : color === "success"
                  ? "success.main"
                  : color === "warning"
                    ? "warning.main"
                    : color === "error"
                      ? "error.main"
                      : "secondary.main",
            mr: 2,
            width: 44,
            height: 44,
          }}
        >
          <Icon sx={{ fontSize: "1.5rem" }} />
        </Avatar>
        <Box sx={{ flex: 1 }}>
          <Typography
            variant="h3"
            component="div"
            fontWeight="bold"
            sx={{ lineHeight: 1.2 }}
          >
            {value}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            fontWeight="medium"
          >
            {title}
          </Typography>
        </Box>
      </Box>

      {/* Enhanced breakdown section */}
      {breakdown && (
        <Box
          sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 1.5 }}
        >
          {breakdown.today !== undefined && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography
                variant="body1"
                color="text.secondary"
                fontWeight="medium"
              >
                Today
              </Typography>
              <Typography
                variant="h5"
                fontWeight="bold"
                color={`${color}.main`}
              >
                {breakdown.today}
              </Typography>
            </Box>
          )}
          {breakdown.week !== undefined && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography variant="body2" color="text.secondary">
                This Week
              </Typography>
              <Typography
                variant="h6"
                fontWeight="bold"
                color={`${color}.main`}
              >
                {breakdown.week}
              </Typography>
            </Box>
          )}
          {breakdown.month !== undefined && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography variant="body2" color="text.secondary">
                This Month
              </Typography>
              <Typography
                variant="h6"
                fontWeight="bold"
                color={`${color}.main`}
              >
                {breakdown.month}
              </Typography>
            </Box>
          )}
          {isEstimate && (
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{
                mt: 1,
                fontStyle: "italic",
                fontSize: "0.65rem",
                display: "block",
              }}
            >
              * Daily/Weekly/Monthly values are estimated
            </Typography>
          )}
        </Box>
      )}

      {/* Custom breakdown section for specialized cards */}
      {!breakdown && customBreakdown && (
        <Box
          sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 1.5 }}
        >
          {customBreakdown}
        </Box>
      )}

      {/* Fallback to subtitle if no breakdown */}
      {!breakdown && !customBreakdown && subtitle && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: "auto" }}>
          {subtitle}
        </Typography>
      )}

      {progress !== undefined && (
        <Box sx={{ mt: 2 }}>
          <LinearProgress
            variant="determinate"
            value={progress}
            color={color}
            sx={{ height: 8, borderRadius: 4 }}
          />
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mt: 1, textAlign: "center", fontWeight: "medium" }}
          >
            {progress}% completion rate
          </Typography>
        </Box>
      )}
    </CardContent>
  </Card>
);

export default StatCard;
